// src/components/trading/AccountOverview.tsx
import React from 'react';
import { TradingAccount } from '../../types/trading';
import LoadingState from '../../components/LoadingState';
import EmptyState from '../../components/EmptyState';

interface AccountOverviewProps {
  account: TradingAccount;
  isLoading: boolean;
}

const AccountOverview: React.FC<AccountOverviewProps> = ({ account, isLoading }) => {
  if (isLoading) {
    return <LoadingState message="Loading account information..." />;
  }

  if (!account) {
    return (
      <EmptyState
        title="No Account Information"
        message="Unable to load account information. Please try refreshing the page."
        action={{
          label: 'Refresh Page',
          onClick: () => window.location.reload()
        }}
      />
    );
  }

  return (
    <div className="bg-white shadow overflow-hidden sm:rounded-lg">
      <div className="px-4 py-5 sm:px-6">
        <h3 className="text-lg leading-6 font-medium text-gray-900">Account Information</h3>
        <p className="mt-1 max-w-2xl text-sm text-gray-500">Details about your trading account.</p>
      </div>
      <div className="border-t border-gray-200">
        <dl>
          <div className="bg-gray-50 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
            <dt className="text-sm font-medium text-gray-500">Account Number</dt>
            <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">{account.accountNumber}</dd>
                </div>
          <div className="bg-white px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
            <dt className="text-sm font-medium text-gray-500">Account Name</dt>
            <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">{account.accountName}</dd>
          </div>
          <div className="bg-gray-50 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                <dt className="text-sm font-medium text-gray-500">Server</dt>
            <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">{account.server}</dd>
              </div>
          <div className="bg-white px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                <dt className="text-sm font-medium text-gray-500">Platform</dt>
            <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">{account.platform}</dd>
              </div>
          <div className="bg-gray-50 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
            <dt className="text-sm font-medium text-gray-500">Connection Status</dt>
            <dd className="mt-1 text-sm sm:mt-0 sm:col-span-2">
              <span className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full ${
                account.isConnected 
                  ? 'bg-green-100 text-green-800' 
                  : 'bg-yellow-100 text-yellow-800'
              }`}>
                {account.isConnected ? 'Connected' : 'Pending'}
              </span>
            </dd>
          </div>
          <div className="bg-white px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
            <dt className="text-sm font-medium text-gray-500">Created At</dt>
            <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
              {account.createdAt instanceof Date ? 
                account.createdAt.toLocaleDateString() : 
                'N/A'}
            </dd>
          </div>
        </dl>
        </div>
    </div>
  );
};

export default AccountOverview;